import { render, staticRenderFns } from "./AppProductSortDialog.vue?vue&type=template&id=011b7b04&scoped=true"
import script from "./AppProductSortDialog.vue?vue&type=script&lang=js"
export * from "./AppProductSortDialog.vue?vue&type=script&lang=js"
import style0 from "./AppProductSortDialog.vue?vue&type=style&index=0&id=011b7b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b7b04",
  null
  
)

export default component.exports